import  './slider.js';
import  './footer-script.js';
import  './custom-select.js';
import  './custom-input-number.js';
import  './single-product.js';
import  './navigation.js';
import  './search-mobile.js';
